/**
 * Clinical Trial Results - Count-up Animation
 */
(function() {
  'use strict';

  function initClinicalTrialResults() {
    // Support both original and text-only variants
    const sections = document.querySelectorAll('.clinical-trial-results, .clinical-trial-results-text');
    if (sections.length === 0) return;

    sections.forEach((section) => {
      // Find all statistics with animation enabled
      const statElements = section.querySelectorAll('[data-animate="true"]');
      if (statElements.length === 0) return;

      const animatedStats = [];

      // Store animation data for each stat
      statElements.forEach((element) => {
        const targetValue = parseInt(element.dataset.target) || 0;
        const valueElement = element.querySelector('.stat-percentage-value');
        
        if (valueElement && targetValue > 0) {
          animatedStats.push({
            element: valueElement,
            target: targetValue,
            current: 0,
            animated: false
          });
        }
      });

      if (animatedStats.length === 0) return;

      // Set up Intersection Observer to trigger animation when section is visible
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.3 // Trigger when 30% of the section is visible
      };

      function animateStats() {
        animatedStats.forEach((stat, index) => {
          if (stat.animated) return;
          
          stat.animated = true;
          
          // Stagger animations slightly
          setTimeout(() => {
            animateValue(stat.element, stat.current, stat.target, 2000);
          }, index * 100);
        });
      }

      function animateValue(element, start, end, duration) {
        const startTime = performance.now();
        const difference = end - start;

        function animate(currentTime) {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          
          // Easing function (ease-out)
          const easeOut = 1 - Math.pow(1 - progress, 3);
          const current = Math.floor(start + (difference * easeOut));
          
          element.textContent = current.toLocaleString();
          
          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            // Ensure final value is set
            element.textContent = end.toLocaleString();
          }
        }

        requestAnimationFrame(animate);
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateStats();
            observer.disconnect();
          }
        });
      }, options);

      observer.observe(section);
    });

  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClinicalTrialResults);
  } else {
    initClinicalTrialResults();
  }
})();
